import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles((theme) => ({
    itemDisabled: {
        minHeight: 0,
        cursor: 'auto',
        '&:hover': {
            backgroundColor: 'initial'
        }
    },
}));

/**
 * Componente para mostrar un componente del menú de usuario deshabilitado.
 * @returns {React.Component}
 */
export default function UserDisabledItem({ children, ...props }) {

    const classes = useStyles();

    return (
        <MenuItem disableRipple className={classes.itemDisabled} {...props}>
            {children}
        </MenuItem>
    )
}
